import { render, staticRenderFns } from "./BuzzCircle.vue?vue&type=template&id=89cabfc6&scoped=true&"
import script from "./BuzzCircle.vue?vue&type=script&lang=js&"
export * from "./BuzzCircle.vue?vue&type=script&lang=js&"
import style0 from "./BuzzCircle.vue?vue&type=style&index=0&id=89cabfc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cabfc6",
  null
  
)

export default component.exports